import React, { Fragment, useCallback, useEffect } from 'react';
import { ModalType, useFormikGoodFilters, useFormikTransferFilters } from '../../../../utils';
import { ShareResponse, useSupervisors } from '../../../../share';
import RequesedItemsView from '../views/RequesedItemsView';
import { useFetchRequestItemById, useFetchRequestItems } from '../../../../hooks/RequestedItems/useRequestedItems';
import { GoodsFilter } from '../../../WarehouseView/types';
import WarehouseManageContainer from '../../../WarehouseView/components/Containers/WarehouseManageContainer';
import GoodsDetailContainer from '../../../Goods/components/Containers/GoodsDetailContainer';

const RequesedItemsViewContainer: React.FC = () => {
  const [modalState, setModalState] = React.useState<{
    type: ModalType;
    id?: string;
  }>({ type: null, id: undefined });

  const [filter, setFilter] = React.useState<GoodsFilter>({});

  const {
    data: goods,
    isPending: loadList,
    refetch,
  } = useFetchRequestItems(filter);

  const { data: detailData, isPending: isLoading, refetch: refetchId } =
      useFetchRequestItemById(modalState.id);

  const handleModalToggle = (
    modalState: { type: ModalType; id?: string },
    setModalState: React.Dispatch<
      React.SetStateAction<{ type: ModalType; id?: string }>
    >,
    type: ModalType,
    id?: string
  ) => {
    setModalState((prev) => ({
      type: prev.type === type ? null : type,
      id: id,
    }));
  };

  const handleFilter = useCallback(
    async (
      values: Partial<GoodsFilter>,
      setFilter: React.Dispatch<React.SetStateAction<GoodsFilter>>
    ) => {
      setFilter({
        ...values,
        created_at: values.created_at
          ? new Date(values.created_at).toISOString().split('T')[0]
          : '',
      });
    },
    []
  );
  
  const formik = useFormikGoodFilters({
    onSubmit: (values) => handleFilter(values, setFilter),
  });

  const handleViewDetail = (id: string) => {
    setModalState({ type: 'detail', id: id });
  };

  const handleManageDetail = (id: string) => {
    setModalState({ type: 'manage', id: id });
  };

  const handlePagination = (page: number) => {
    setFilter({
      page: page.toString(),
    });
  };

  const transferStates: ShareResponse[] = [
    { id: '25', name: 'Pendiente' },
    { id: '13', name: 'Entregado' },
    { id: '14', name: 'No entregado' },
    { id: '15', name: 'Recibido' },
    { id: '16', name: 'No recibido' },
  ];

  useEffect(() => {
    refetch();
  }, [filter, refetch]);

  useEffect(() => {
    if (modalState.id) {
      refetchId();
    }
  }, [modalState, refetchId]);

  return (
    <Fragment>
      {modalState.type === 'manage' && (
        <WarehouseManageContainer
          isOpen={modalState.type === 'manage'}
          OnClose={() => {
            handleModalToggle(modalState, setModalState, 'manage');
            formik.resetForm();
          }}
          isLoading={loadList}
          data={detailData}
          refetch={refetch}
          isApproveRequest={false}
        />
      )}
      {modalState.type === 'detail' && detailData && (
        <GoodsDetailContainer
          isOpen={modalState.type === 'detail'}
          OnClose={() => {
            handleModalToggle(modalState, setModalState, 'detail');
            formik.resetForm();
          }}
          data={detailData}
          refetch={refetch}
          isApproveRequest={false}
          isRequestedItems
        />
      )}
      <RequesedItemsView
        isLoading={loadList}
        data={goods}
        states={transferStates}
        formik={formik}
        onViewDetail={handleViewDetail}
        onManageDetail={handleManageDetail}
        onPagination={handlePagination}
        onResetFilters={() => {
          handleFilter({}, setFilter);
          formik.resetForm();
        }}
      />
    </Fragment>
  );
};

export default RequesedItemsViewContainer;
